import React, {useState, useEffect} from "react";
// import "react-modern-calendar-datepicker/lib/DatePicker.css";
// import { Calendar } from "react-modern-calendar-datepicker";
// import { utils } from 'react-modern-calendar-datepicker';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import classNames from 'classnames';
import Button from '../components/common/Button'
import formatAttendDate from '../util/formatAttendDate'
import axios from 'axios'

const Attendance = ({fetchedAtt}) => {

    const [value, onChange] = useState([new Date, new Date]);

    const [fetchedAttendance, setFetchedAttendance] =  useState([]);
    const [loading, setLoading] = useState(false);
    const [fetchError, setFetchError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    // const [showDate, setShowDate] = useState(false);

    const studentInfo = JSON.parse(localStorage.getItem('studentInfo'));
    const admissionnumber = studentInfo[0].admissionnumber;
    // const schoolDomain = window.location.host;
    const schoolDomain = localStorage.getItem('schoolDomain');

    const formatDatesForRequest = () => {
        const startDate = `${value[0].getFullYear()}-${value[0].getMonth() + 1}-${value[0].getUTCDate() + 1}`;
        const endDate = `${value[1].getFullYear()}-${value[1].getMonth() + 1}-${value[1].getUTCDate()}`;
        return {
            startDate,
            endDate
        }
    }

    const formatSelectedDates = () => {
        const startMonth = value[0].toString().substring(4,7);
        const startDay = value[0].toString().substring(8,10);
        const endMonth = value[1].toString().substring(4,7);
        const endDay = value[1].toString().substring(8,10);
        return `${startMonth}${" "}${startDay} to ${endMonth}${" "}${endDay}`
    }

    const onSubmit = async () => {
        const date = formatDatesForRequest();

        const attendanceBody = {
            // SchoolUrl: 'demo.edves.net',
            SchoolUrl: schoolDomain,
            admissionnumber,
            startdate : date.startDate,
            enddate : date.endDate
        }
        console.log(attendanceBody)
        try {
            setLoading(true)
            setErrorMessage('')
            setFetchError(false)
            const { data } = await axios.post(`student/viewattendance`, attendanceBody);
            console.log(data.data)
            if (!data.status) {
                setFetchError(true); 
                setErrorMessage(data.message)
            } else {
                setFetchedAttendance(data.data);
            };
            console.log(fetchedAttendance)
            setLoading(false);
        } catch (error) {
            console.log('get attendance error', error)
        }
    };

    return (
        <div className="lg:w-4/5 sm:-ml-12 sm:mr-4 lg:-ml-16 sm:bg-white rounded-lg py-8 mt-12 sm:mt-6">
            <div className='flex w-full items-center'>
                {/* <span className="hidden text-gray-200 text-base font-bold leading-5 sm:flex mt-4 mb-4"> Selected days range </span> */}
                <div className='w-full flex justify-between items-center px-4'>
                    <div className="w-64 sm:mx-0 sm:w-1/5 px-2 sm:px-1 pt-4">
                        <DateRangePicker
                            onChange={onChange}
                            value={value}
                            isOpen = {false}
                        />
                    </div>
                    <div className=''>
                        <Button
                            //type='submit'
                            text='search'
                            loading={loading}
                            onClick={onSubmit}
                        />
                    </div>
                </div>
            </div>
            <div className='w-full sm:w-full sm:mx-0 sm:flex' >
                
                <div className="w-full block  sm:mr-5 mt-4 ">
                    <div className='flex w-full justify-center  text-gray-200 text-base leading-5 font-semibold'>
                        {value ? formatSelectedDates() : ''}
                    </div>
                    <div className="w-full mt-3 flex flex-col justify-center">
                        { fetchError ? <div className='text-red-200 text-sm m-auto'> {errorMessage} </div> 
                        :
                        fetchedAttendance && fetchedAttendance.map(pupil => {
                            const punctualityColor = classNames({
                                "ml-4 sm:ml-2 mr-4 pl-4 py-3 rounded-md text-xs leading-3 w-full" : true,
                                "bg-green-800" : pupil.message === "Present AND Punctual",
                                "bg-yellow-700" : pupil.message === "Absent AND Late",
                                "bg-red-800" : pupil.message === "Absent AND Authorized Absenteeism",
                                // "bg-gray-700" : pupil.index === "0"
                            })
                            return (
                            <div className="flex-col sm:flex sm:flex-row sm:mb-0 mb-2 sm:w-4/5">
                                <span className="flex pl-4 sm:pl-0 sm:ml-0 sm:justify-end items-center leading-4 w-full sm:w-1/3 text-sm mr-4"> {formatAttendDate(pupil.dateattended)} </span>
                                <div className="w-full sm:w-2/3 sm:pl-1 sm:pr-4 py-2 border-0 sm:border sm:border-gray-700 flex justify-start items-center">
                                    <span className={punctualityColor}> {pupil.message} </span>
                                </div>
                            </div>
                        )})}
                    </div>
                </div>
                {/* <div className="hidden sm:block w-64 sm:w-1/2 px-1 mt-0 pt-3">
                    <DateRangePicker
                        onChange={onChange}
                        value={value}
                        isOpen = {false}
                        closeCalendar = {true}
                    />
                    <Calendar       
                        value={selectedDays}
                        onChange={(e) => setSelectedDays(e.target.value)} 
                        shouldHighlightWeekends
                    />
                </div> */}
            </div>
        </div>
    )
}
export default Attendance;